export const AZURE_RESERVABLE_ENVIRONMENTS = {
    DEV: 'dev',
    RELEASE: 'release'
};
